import { useInfiniteQuery } from '@tanstack/react-query';
import { pick } from 'lodash';

import { Groups } from '@app/client';

import { useGroupFilterParams } from './useGroupFilterParams';
import { useGroupId } from './useGroupId';
import { getNextPageParam, groupsCacheKeys } from './utils';

/**
 * React Hook using React Query to call `/groups/:groupId/collections`.
 */
export const useGetGroupCollections = (names: string) => {
    const groupId = useGroupId();

    const filters = useGroupFilterParams();

    const collectionsFilters = names ? { ...pick(filters, ['spam']), names } : pick(filters, ['spam']);

    const cache = groupsCacheKeys.collections(groupId, collectionsFilters);

    return useInfiniteQuery(
        cache,
        ({ pageParam = 0, signal }) =>
            Groups.callGetGroupCollections({
                groupId,
                query: { page: pageParam || 0, limit: 6, ...collectionsFilters },
                settings: { signal },
            }),
        {
            retry: false,
            keepPreviousData: true,
            enabled: Boolean(groupId),
            getNextPageParam,
        },
    );
};
